import { render, staticRenderFns } from "./pos-boxes.vue?vue&type=template&id=517b2c97&scoped=true&"
import script from "./pos-boxes.ts?vue&type=script&lang=ts&"
export * from "./pos-boxes.ts?vue&type=script&lang=ts&"
import style0 from "./pos-boxes.scss?vue&type=style&index=0&id=517b2c97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b2c97",
  null
  
)

export default component.exports